export const authRoutes = {
  'login': process.env.REACT_APP_AUTH_DOMAIN + '/user/login',
  'signup': process.env.REACT_APP_AUTH_DOMAIN + '/user/signup',
  'logout': process.env.REACT_APP_AUTH_DOMAIN + '/user/logout',
};
